import { Drawer, styled } from "@mui/material";

export const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: 250,
    border: 0,
    borderRadius: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});
